<template>
  <el-dialog :visible.sync="deleteVisible" :before-close="handlerClose" :show-close="false">
    <div slot="title" class="el-dialog__title">
      <div class="title-left"></div>
      <slot name="title">{{$t('managementV2.delete')}}</slot>
      <div class="title-right"></div>
    </div>
    <div class="tips">{{deletTips}}</div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handlerClose" size="small">{{$t('managementV2.cancel')}}</el-button>
      <el-button type="primary" @click="determine" size="small">{{$t('managementV2.determine')}}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { deleteClass, deleteClassUser } from "@/services/managements";
export default {
  name: "deleteDialog",
  data() {
    return {
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    }
  },
  props: {
    deleteVisible: {
      type: Boolean,
      default: () => false,
    },
    deletTips: {
      type: String,
      default: () => ""
    },
    deleteId: {
      type: Number,
    },
    deleteIdList: {
      type: Array,
      // default: () => []
    },
    deleteType: {
      type: String,
    }
  },
  methods: {
    //关闭
    handlerClose() {
      this.$emit("handlerdeleteClose")
    },
    //确定
    async determine() {
      if (this.deleteType === 'class') {
        const { success } = await deleteClass({ id: this.deleteId, companyCode: this.companyCode });
        if (success) {
          this.$message.success(this.$t('managementV2.Classdeletedsuccessfully'));
          this.$emit("handlerdeleteSuccess")
        }
      } else {
        const { success } = await deleteClassUser({ idList: this.deleteIdList, companyCode: this.companyCode });
        if (success) {
          this.$message.success(this.$t('managementV2.Studentdeletedsuccessfully'));
          this.$emit("handlerdeleteSuccess")
        }
      }

    },
  }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  width: 453px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0px !important;
  padding: 0 54px;
  box-sizing: border-box;
  border-radius: 12px 12px 12px 12px;
  .el-dialog__header {
    height: 58px;
    padding: 0px;
    border-bottom: 2px solid rgba(86, 96, 135, 0.1);
    .el-dialog__title {
      font-size: 18px;
      height: 18px;
      display: inline-block;
      line-height: 18px;
      font-weight: bold;
      color: #566087;
      margin-top: 17px;
      .title-left,
      .title-right {
        width: 6px;
        height: 18px;
        display: inline-block;
        vertical-align: top;
      }
      .title-left {
        margin-right: 9px;
        background: url("~@/components/layer/addUser/assets/images/popup_icon_Left.png")
          no-repeat center 5px;
      }
      .title-right {
        margin-left: 9px;
        background: url("~@/components/layer/addUser/assets/images/ppup_icon_right.png")
          no-repeat center 5px;
      }
    }
  }
  .el-dialog__body {
    padding: 25px 0px 0px 0px;
    .tips {
      font-size: 16px;
      color: #333;
    }
  }
  .el-dialog__footer {
    padding: 30px 0px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 76px;
    }
    .el-button + .el-button {
      margin-left: 20px;
    }
    .el-button--default {
      border: 1px solid #0078fc;
      color: #0078fc;
    }
  }
}
</style>